import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

interface ToastProps {
    showToast: boolean,
    setShowToast: React.Dispatch<React.SetStateAction<boolean>>,
    toastContents: {header: string, body: string, severity?: 'error' | 'info' | 'success' | 'warning'}
}

export const ToastNotification = (props: ToastProps) => {

    return (
      <Snackbar
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}
        open={props.showToast}
        onClose={() => props.setShowToast(false)}
        autoHideDuration={3000}> 
        <Alert severity={props.toastContents.severity? props.toastContents.severity : 'success'} variant='filled'>
          <AlertTitle>{props.toastContents.header}</AlertTitle>
          {props.toastContents.body}
          </Alert>
        </Snackbar>
      )
  }